import React, {useState} from 'react'
import {
  Typography,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TextField
} from '@material-ui/core'

import LoadingButton from '../../LoadingButton';
import { receiveLineItems } from '../../../api/resources/LineItems';

import { withStyles } from '@material-ui/styles';

const styles = {
  input: {
    '& input[type=number]': {
      textAlign: 'right',
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
    }
  },
};

const columnWidths = {
  description: 'auto',
  ordered: '110px',
  received: '110px',
}

function ReceiveLineItems({lineItems, onClose, onReceive, classes}) {

  lineItems = lineItems.map(li => ({...li, received: li.received || 0}))

  const [LineItems, setLineItems] = useState(lineItems)
  const [isSaving, setIsSaving] = useState(false)

  const markReceived = () => {
    setIsSaving(true);
    const lineItems = LineItems.map(li => {
      const {isEditing, isNew, lineNumber, ...rest} = li;
      return {...rest};
    });

    const allReceived = lineItems.every(li => li.received === li.quantity);

    receiveLineItems({lineItems, allReceived}).then(res => {
      onReceive(LineItems, res);
      if (allReceived) {
        alert("All items received. PO moved to the 'Received' tab.")
      }
      onClose();
    });
  }

  const updateReceived = (received, idx) => {
    received = parseFloat(received)
    const lis = LineItems;
    const li = lis[idx];
    if (received > li.quantity) received  = li.quantity;
    if (received < 0) received = 0;
    if (isNaN(received)) received = ``;
    lis[idx] = {...li, received};
    setLineItems(lis => [...lis]);
  }

  return (
    <>
      <div style={{marginBottom: '16px', width: '500px'}}>
        <Typography variant="h5">Receive line items</Typography>
        <Typography style={{fontSize: '14px', marginTop: '4px', color: '#888'}}>Note: Mark <strong>total quantities</strong> received to-date</Typography>
      </div>
      <TableContainer style={{marginBottom: '32px'}}>
        <Table aria-label="simple table" size='small'>
          <TableHead>
            <TableRow>
              <TableCell align="left" width={columnWidths.description}><strong>Description</strong></TableCell>
              <TableCell align="right" width={columnWidths.ordered}><strong>Ordered</strong></TableCell>
              <TableCell align="right" width={columnWidths.received}><strong>Received</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { LineItems.map((lineItem, idx) => (
              <TableRow key={idx}>
                <TableCell width={columnWidths.description}>
                  <Typography>{lineItem.description}</Typography>
                </TableCell>
                <TableCell align="right" width={columnWidths.quantity}>
                  <Typography>{lineItem.quantity}</Typography>
                </TableCell>
                <TableCell width={columnWidths.received}>
                  <TextField
                    type="number"
                    name="received"
                    value={lineItem.received}
                    placeholder="-"
                    className={classes.input}
                    inputProps={{style: {textAlign: 'right'}}}
                    InputProps={{ minimum: 0, disableUnderline: false, style: {textAlign: 'right'} }}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    onChange={(event) => updateReceived(event.target.value, idx)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <LoadingButton
        color="primary"
        variant="contained"
        loading={isSaving}
        onClick={markReceived}
        fullWidth
      >Update quantities received</LoadingButton>
    </>
  )
}

export default withStyles(styles)(ReceiveLineItems);
